<div class="card h-100">
  <div *ngIf="showHeader" class="header">
    <h1 class="text-primary">Document Upload</h1>
  </div>
  <div class="card-body">
    <div class="row">
      <div *ngIf="!getHasFiles()" class="col-12 mb-3">
        <div
          (click)="openFileDialog()"
          (onFileDrop)="setSelectedFile($event)"
          [uploader]="uploader"
          class="card card-body border border-primary drop-zone text-center p-4 mb-1"
          ng2FileDrop>
          Drop or select a single document to upload or multiple documents to
          combine.
        </div>
      </div>
      <div class="col-12">
        <button (click)="openFileDialog()" class="btn btn-secondary">
          Browse {{ getHasFiles() ? ' to add more' : '' }}
        </button>
        <span *ngIf="!getHasFiles()" class="ms-2"> No image selected</span>
      </div>
      <div *ngIf="getHasMultipleFiles()" class="mt-4 col-12 mb-2">
        <span>Drag files to order them correctly</span>
      </div>
      <div class="col-12 mt-3">
        <app-reordering-list-display
          (buttonClicked)="removeFile($event)"
          (dropEventEmitter)="reorderItems($event)"
          [buttonIcon]="'cross-circle'"
          [data]="getFileNames()"
          [showButtons]="true">
        </app-reordering-list-display>
      </div>
      <div class="col-12">
        <input
          #fileInput
          (onFileSelected)="setSelectedFile($event)"
          [multiple]="true"
          [uploader]="uploader"
          [accept]="getAcceptedExtensions()"
          class="d-none"
          ng2FileSelect
          type="file" />
      </div>
      <div class="col-12 mt-3">
        <button
          (click)="clearSelection()"
          *ngIf="getHasFiles()"
          class="btn btn-danger">
          Clear all
        </button>
      </div>
    </div>
  </div>
</div>
